import { Injectable } from '@angular/core';
import { environment } from "src/environments/environment";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { NotificationService } from 'src/app/signalr/notification.service';
import FeaUtils from '../../FeaUtils';
import { FeaBaseProcessService } from './fea-base-process.service';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FeaMOUService {

  constructor(
    private readonly feaBaseProcessService : FeaBaseProcessService,
    private readonly http: HttpClient,
    private readonly notificationService: NotificationService,
  ) {
  }

  public async getResult(vectorName: string) : Promise<any> {
    const baseRequest = await this.feaBaseProcessService.getBaseProcessRequest();
    const request = {
      ...baseRequest,
      ResultType: "Single",
      //OutputSet: "1", // While we cannot choose the output, choose the latest
      Vector: vectorName
    };

    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache',
        'Expires': '0'
      }),
      responseType: 'text' as 'text'
    };

    try {
      const url = await firstValueFrom(this.http.post(environment.API_FEA + `MOU/GetResult`, request, options));
      const csvText = await firstValueFrom(this.http.get(url, { responseType: 'text' as 'text' }));
      var valuesPerElement = FeaUtils.ExtractValuesFromCSV(csvText);
      var title = `Code Check: MOU - Output Set: 1 \nOutput Vector: ${vectorName.replace("/", ":")}`;
      return {
        valuesPerElement: valuesPerElement,
        title: title
      };
    }
    catch (err) {
      console.log(err);
      this.notificationService.addFailedNotification("Failed to get or parse MOU result");
      return null; // Indicate failure
    }
  }
}
